import React from "react";
import { cn } from "@/lib/utils";
import { typographyVariants, type TypographyVariants } from "./index.styles";

interface TypographyProps extends TypographyVariants {
  children: React.ReactNode;
  className?: string;
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span" | "label";
}

export const Typography: React.FC<TypographyProps> = ({
  children,
  variant,
  color,
  className,
  as = "p",
}) => {
  const Component = as;

  return (
    <Component
      className={cn(typographyVariants({ variant, color }), className)}
    >
      {children}
    </Component>
  );
};

export default Typography;
